import isNil from 'lodash/isNil';

export default function SafeString(string: string) {
  return isNil(string) ? '' : String(string);
}
